import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IUserSelectorBuilder from "../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

type Inputs = "representante";
type Buttons = "aceptar" | "cancelar";

export const programaReglamentoFormConfig: FormBuilderConfig<
  Inputs,
  Buttons
> = {
  inputs: [
    {
      name: "representante",
      label: "Representante",
      bts: {
        xCol: 12
      },
      component: IUserSelectorBuilder
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Aceptar",
      isSubmit: true,
      bts: {
        mCol: 3,
        mOff: 6
      },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    representante: {
      required: true
    }
  },
  rows: [["representante", "aceptar", "cancelar"]]
};
